import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { resolveStoreDocumentTitle } from "@/utils/documentTitle.js";

/** Sets the browser tab title from the current route (product/order pages own their titles). */
export default function StoreDocumentTitle() {
    const { pathname, search } = useLocation();

    useEffect(() => {
        const title = resolveStoreDocumentTitle(pathname, new URLSearchParams(search));
        if (title) {
            document.title = title;
        }
    }, [pathname, search]);

    return null;
}
